import { Editor } from "@tinymce/tinymce-react";
import React, { ReactElement, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { DialerService } from "./";

interface IParams {
	leadId: string;
	showNotesEditor: boolean;
	showSaveButton: boolean;
	callDuration: number;
	callId: number;
	onSave(): void;
}

const INITIAL_EDITOR_CONTENT =
	'<table border="1"><tbody><tr><td style="width: 30%"><strong>Question</strong></td><td><strong>Answer</strong></td></tr><tr><td >Client needs</td><td>&nbsp;</td></tr><tr><td >Pain points in current products</td><td>&nbsp;</td></tr><tr><td >&nbsp;</td><td>&nbsp;</td></tr><tr><td >Would like to set up a demo? ( eLearning ) or call back with an AE ( Courseware )</td><td>&nbsp;</td></tr><tr><td >Timeline</td><td>&nbsp;</td></tr><tr><td >Notes</td><td>&nbsp;</td></tr></tbody></table><p>&nbsp;</p>';

export const DialerNotesForm = (props: IParams): ReactElement => {
	const [note, setNote] = useState<string>(INITIAL_EDITOR_CONTENT);
	const [callResult, setCallResult] = useState<string>("Contact");

	const dialerService = new DialerService();

	const saveNotes = async () => {
		const message = await dialerService.logCall(
			props.leadId,
			callResult,
			props.callDuration,
			note,
			props.callId,
		);

		toast.success(message);
		props.onSave();
	};

	return (
		<>
			<div
				style={{
					maxWidth: "65%",
					margin: "0 auto",
					textAlign: "left",
				}}
			>
				{props.showNotesEditor ? (
					<Form.Group className="mt-3" style={{ color: "#000" }}>
						<Editor
							initialValue={INITIAL_EDITOR_CONTENT}
							init={{
								height: 400,
								menubar: false,
								plugins: [
									"advlist autolink lists link anchor",
									"table paste",
								],
								toolbar:
									"undo redo | formatselect | bold italic color | \
             							alignleft aligncenter alignright alignjustify | \
             							bullist numlist | table",
							}}
							onEditorChange={(content: any) => setNote(content)}
						/>
					</Form.Group>
				) : (
					""
				)}

				{props.showSaveButton ? (
					<>
						<Form.Group>
							<Form.Label>Result</Form.Label>
							<Form.Control
								as="select"
								onChange={event => {
									const target = event.target as HTMLSelectElement;
									setCallResult(target.value);
								}}
							>
								<option>Contact</option>
								<option>No Answer</option>
								<option>Scheduled Meeting</option>
								<option>Scheduled Demo</option>
								<option>Bad Number</option>
								<option>Wrong Number</option>
								<option>Voicemail</option>
							</Form.Control>
						</Form.Group>
						<Button onClick={saveNotes}>Save</Button>
					</>
				) : (
					""
				)}
			</div>
		</>
	);
};
